import React from "react";

import {rpCommonUrl} from "../../read_rp_environment_variables";
import {IBreadcrumb} from "./IBreadcrumb";

interface IProps {
    items: IBreadcrumb[];
}

export const SchemaBreadcrumbs = ({items}: IProps) => {
    const json = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: items.map((item, index) => ({
            "@type": "ListItem",
            position: index + 1,
            name: item.name,
            ...(item.url !== undefined ? {item: `${rpCommonUrl}${item.url}`} : {})
        }))
    };

    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(json)}} />;
};
import React from "react";

import {rpCommonUrl} from "../../read_rp_environment_variables";
import {IBreadcrumb} from "./IBreadcrumb";

interface IProps {
    items: IBreadcrumb[];
}

export const SchemaBreadcrumbs = ({items}: IProps) => {
    const json = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: items.map((item, index) => ({
            "@type": "ListItem",
            position: index + 1,
            name: item.name,
            ...(item.url !== undefined ? {item: `${rpCommonUrl}${item.url}`} : {})
        }))
    };

    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(json)}} />;
};
